import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

interface CurrentUser {
  access_token: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandleService {
  constructor(private http: HttpClient) { }

  errorHandl(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Client Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Server Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error('An error occurred:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  _httpOptions(formData?: boolean) {
    const currentUser = localStorage.getItem('currentUser');
    let parsedUser: CurrentUser | null = null;

    try {
      parsedUser = currentUser ? JSON.parse(currentUser) : null;
    } catch (error) {
      console.error('Error parsing user data:', error);
    }

    const isLoggedIn = localStorage.getItem('token');

    if (isLoggedIn) {
      if (formData) {
        return {
          headers: new HttpHeaders({
            'Authorization': `Bearer ${isLoggedIn}`,
            'referer-policy': 'no-referrer-when-downgrade'
          })
        };
      }

      return {
        headers: new HttpHeaders({
          'Content-Type': formData ? 'multipart/form-data' : 'application/json',
          'Authorization': `Bearer ${isLoggedIn}`,
          'referer-policy': 'no-referrer-when-downgrade'
        })
      };
    }

    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'referer-policy': 'no-referrer-when-downgrade'
      })
    };
  }
}
